var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from "../../../pages/modules/base-entity";
import { autoinject, transient, BindingEngine } from "aurelia-framework";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { Router } from "aurelia-router";
import { NotificationClientService } from "../../../../services/basics/notification-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { EntityTypes } from "../../../../models/basics/basics.models";
import { RouterConstants } from "../../../../configuration/router.constants";
import { I18N } from "aurelia-i18n";
import { StepEnum } from "../../../../models/modules/lotteryplatofrm.models";
import { TicketDrawClientService } from "../../../../services/modules/ticket-draw-client.service";
import { TicketDrawBasicMeta } from "./steps/ticket-draw-basic-meta";
var TicketDraws = /** @class */ (function (_super) {
    __extends(TicketDraws, _super);
    function TicketDraws(dialogClientService, router, bindingEngine, notificationService, eventAggregator, i18N, ticketDrawClientService, ticketDrawBasicMeta) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.ticketDrawClientService = ticketDrawClientService;
        _this.ticketDrawBasicMeta = ticketDrawBasicMeta;
        _this.activityLogEntitiesSave = [EntityTypes.Player];
        return _this;
    }
    TicketDraws.prototype.activate = function (params, navigationInstruction) {
        return _super.prototype.activate.call(this, params, navigationInstruction);
    };
    TicketDraws.prototype.attached = function () {
        return _super.prototype.attached.call(this);
    };
    TicketDraws.prototype.getSteps = function () {
        return [
            {
                title: this.i18N.tr("transaction-draw-overview"),
                step: StepEnum.TicketDrawsOverview,
                vm: this.ticketDrawBasicMeta,
                show: true,
                view: "../../app/admin/ticket-draws/steps/ticket-draw-basic-meta.html"
            },
        ];
    };
    TicketDraws.prototype.getItem = function (id) {
        var request = { id: id };
        return this.ticketDrawClientService.getTicketDraw(request);
    };
    TicketDraws.prototype.getItemId = function () {
        return this.item.gamePlayerTicketDrawId;
    };
    TicketDraws.prototype.getEntityType = function () {
        return null;
    };
    TicketDraws.prototype.beforeSave = function (skipValidation, resolve) {
        return null;
    };
    TicketDraws.prototype.saveItem = function (id, changes) {
        return null;
    };
    TicketDraws.prototype.getUpdateRoute = function () {
        return null;
    };
    TicketDraws.prototype.initializeItemForCreate = function () {
        return null;
    };
    TicketDraws.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListTicketLineDraws;
    };
    TicketDraws = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService,
            Router, BindingEngine, NotificationClientService,
            EventAggregator, I18N, TicketDrawClientService, TicketDrawBasicMeta])
    ], TicketDraws);
    return TicketDraws;
}(BaseEntity));
export { TicketDraws };
